import { Add } from "@mui/icons-material";
import { Box, Paper, Typography } from "@mui/material";
import Search from "../../../components/search/Search";
import useResponsive from "../../../components/hooks/useResponsive";
import { useRoiPersonalWatchContext } from "../../../context/roi/personal-watch/RoiPersonalWatchContext";
import Loading from "../../../components/loader/Loading";
import RoiPersonalWatchCard from "./RoiPersonalWatchCard";
import Grid2 from "@mui/material/Unstable_Grid2";
import RoiAddPersonalWatch from "./RoiAddPersonalWatch";
import RoiDeletePersonalWatch from "./RoiDeletePersonalWatch";
import NotFound from "../../../components/notfound/NotFound";
import RoiPersonalWatchStocks from "./RoiPersonalWatchStocks";

const RoiPersonalWatch = () => {
  const { filteredWatches, isLoadingWatches, setIsAddModal } =
    useRoiPersonalWatchContext();

  const { isMd } = useResponsive();
  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "14px",
        minHeight: "88vh",
        height: "100%",
      }}
    >
      {isLoadingWatches ? (
        <Loading />
      ) : (
        <>
          <Box
            sx={{
              display: "flex",
              alignItems: { xs: "none", md: "center" },
              justifyContent: "space-between",
              flexDirection: { xs: "column", md: "row" },
              gap: "14px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: { xs: "none", md: "center" },
                flexDirection: { xs: "column", md: "row" },
                gap: "14px",
              }}
            >
              <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
                  دیده‌بان شخصی
              </Typography>

              <button
                onClick={() => setIsAddModal(true)}
                className="btn btn-softblue"
                style={{
                  fontSize: "10px",
                  width: isMd ? "fit-content" : "100%",
                }}
              >
                  دیده‌بان جدید
                <Add sx={{ width: "18px" }} />
              </button>
            </Box>
            <Search
              placeholder="جستجو: دیده‌بان"
              width={!isMd ? "" : "250px"}
            />
          </Box>

          {/* modals  */}
          <RoiAddPersonalWatch />
          <RoiDeletePersonalWatch />
          <RoiPersonalWatchStocks />

          {filteredWatches.length < 1 ? (
            <NotFound />
          ) : (
            <Grid2 container spacing={"14px"}>
              {filteredWatches?.map((data, i) => (
                <Grid2 key={i} xs={6} sm={4} md={3} lg={2} xl={1.5}>
                  <RoiPersonalWatchCard data={data} />
                </Grid2>
              ))}
            </Grid2>
          )}
        </>
      )}
    </Paper>
  );
};

export default RoiPersonalWatch;
